import { API_V2 } from '@Models/GWDomain';
import { getData, postData, putData } from '../../../services/constServices';

const baseUrl = `${API_V2}/onboarding`;

export const getOnboardingProgress = () => getData(`${baseUrl}/progress`);

export const updateOnboardingProgress = (data: Record<string, number>) =>
  putData(`${baseUrl}/progress`, data);

export const trackOnboardingEvent = (data: {
  eventType: string;
  module?: string;
  stepNumber?: number;
  metadata?: any;
}) => postData(`${baseUrl}/events`, data);

export const updateBusinessType = (businessType: number) =>
  putData(`${baseUrl}/business-type`, { businessType });

export const getChecklistStatus = () => getData(`${baseUrl}/checklist-status`);
